import React from "react";
import { CmpTemplates } from "../../components/template/CmpTemplates";
import NotFoundPageContent from "../../components/organisms/NotFoundPageContent";
import { Button } from "../../components/atoms/Buttons";
import { useNavigate } from "react-router";

const UserPasswordChangePage = () => {
  const navigate = useNavigate();
  return (
    <CmpTemplates pageTitle="비밀번호 찾기">
      <>
        <NotFoundPageContent contentText="관리자에게 문의하시길 바랍니다." />
        <Button
          type="button"
          size="full"
          color="primary"
          label="확인"
          onClick={() => navigate(-1)}
        />
      </>
    </CmpTemplates>
  );
};

export default UserPasswordChangePage;
